'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TiktokBlock = exports.InstagramPostBlock = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _dyzioInstagramThumbnail = require('../../components/dyzio-instagram-thumbnail');

var _dyzioInstagramThumbnail2 = _interopRequireDefault(_dyzioInstagramThumbnail);

var _influencerReportCard = require('../influencer-report-card');

var _formatting = require('../../utils/formatting');

var _storyComponents = require('./story-components');

var _dyzioIcons = require('../../components/dyzio-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JL = 'cfa6155e-0b5e-4ebc-8150-c8715217fdc8';
var GIFTA = '2beaa438-af69-46f1-b639-f7ae1f374241';

var DEFAULT_IMAGE = 'https://ri.dyzio.co/no_image_available.png';

var tiktokIconStyle = {
  marginLeft: 0,
  marginTop: 0,
  marginBottom: 0,
  marginRight: 0
};

var buttonStyle = {
  marginLeft: 10,
  textTransform: 'uppercase'
};

var avatarStyle = {
  width: 80,
  height: 80,
  float: 'left',
  margin: '0 0 0 0',
  backgroundColor: 'gray',
  display: 'inline-block'
};

var handleStyle = {
  padding: '15px 5px 5px 5px',
  marginLeft: 20,
  float: 'left',
  display: 'inline-block',
  fontSize: 16
};

var statsStyle = {
  marginTop: 10
};

var statisticValueStyle = {
  color: '#e93578'
};

var segmentStyle = { height: 460, marginTop: 10, marginBottom: 10 };

var captionStyle = { paddingTop: 10, color: 'black', 'overflow-wrap': 'anywhere' };

var imageStyle = {
  height: 290,
  margin: '0 auto 20px auto',
  display: 'block',
  backgroundColor: 'transparent',
  objectFit: 'contain'
};

var openURL = function openURL(url) {
  window.open(url, '_blank');
};

var tiktokEngagementRate = function tiktokEngagementRate(tiktok) {
  var followerCount = _lodash2.default.get(tiktok, 'initialData.authorMeta.fans');
  var latestData = _lodash2.default.last(_lodash2.default.get(tiktok, 'tiktokData'));
  var engagements = _lodash2.default.get(latestData, 'diggCount', 0) + _lodash2.default.get(latestData, 'shareCount', 0) + _lodash2.default.get(latestData, 'commentCount', 0);
  return engagements / followerCount * 100;
};

var instagramEngagementRate = function instagramEngagementRate(post) {
  var commentCount = _lodash2.default.get(post, 'commentCount', 0);
  var likeCount = _lodash2.default.get(post, 'likeCount', 0);
  var followerCount = _lodash2.default.get(post, 'followerCount', 0);
  var engagements = commentCount + likeCount;
  return engagements / followerCount * 100;
};

var getInstagramType = function getInstagramType(a) {
  if (a.trackedAsset.assetType === 'STORY') {
    return 'STORY';
  }

  if (a.isReel) {
    return 'REEL';
  }

  if (a.isIGTV) {
    return 'IGTV';
  }

  if (a.isVideo) {
    return 'VIDEO';
  }

  if (a.isCarousel) {
    return 'CAROUSEL';
  }

  return 'IMAGE';
};

var InstagramStoryBlock = function InstagramStoryBlock(props) {
  var imgUrl = props.savedThumbnailUrl || props.attributes && props.attributes.savedThumbnailUrl;
  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true, style: segmentStyle, color: 'pink' },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { textAlign: 'center' },
      _react2.default.createElement(_storyComponents.StoryImageModalComponent, { story: props }),
      _react2.default.createElement(_storyComponents.StoryIconModalComponent, { story: props }),
      !(_lodash2.default.get(props, 'playCount') && !_lodash2.default.get(props, 'viewCount')) && (_lodash2.default.get(_lodash2.default.get(props, 'attributes'), 'assetType') === 'VIDEO' || _lodash2.default.get(props, 'insights.views')) && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'pink' },
        'views: ',
        _lodash2.default.get(props, 'attributes.latestImpressions') ? (0, _formatting.sciFormatted)(_lodash2.default.get(_lodash2.default.get(props, 'attributes'), 'latestImpressions', 0)) : _lodash2.default.get(props, 'insights.views', 0)
      ),
      _react2.default.createElement(
        'p',
        { style: captionStyle },
        _lodash2.default.truncate(_lodash2.default.get(props, 'text'), { length: 190 })
      )
    )
  );
};

var InstagramPostBlock = exports.InstagramPostBlock = function InstagramPostBlock(props) {
  return _react2.default.createElement(
    _semanticUiReact.Card,
    {
      fluid: true, style: segmentStyle, onClick: function onClick() {
        return openURL(_lodash2.default.get(props, 'trackedAsset.assetURL', _lodash2.default.get(props, 'assetURL')));
      }, color: 'blue'
    },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { textAlign: 'center' },
      props.platform != 'TIKTOK' && _react2.default.createElement(_dyzioInstagramThumbnail2.default, {
        customStyle: imageStyle,
        assetId: _lodash2.default.get(props, 'instagramId'),
        fallbackURL: _lodash2.default.get(props, 'thumbnail'),
        trackedAssetId: _lodash2.default.get(props, 'trackedAsset.id')
      }),
      props.platform === 'TIKTOK' && _react2.default.createElement(_semanticUiReact.Image, {
        style: imageStyle,
        src: _lodash2.default.get(props, 'savedThumbnailUrl'),
        onError: function onError(i) {
          i.target.src = DEFAULT_IMAGE;
        }
      }),
      props.platform === 'TIKTOK' && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'black' },
        'Tiktok'
      ),
      props.platform != 'TIKTOK' && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'pink' },
        'Instagram ',
        getInstagramType(props)
      ),
      props.platform === 'TIKTOK' && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'black' },
        'ER: ',
        (0, _formatting.percentFormatted)(tiktokEngagementRate(props)),
        '%'
      ),
      props.platform != 'TIKTOK' && _lodash2.default.get(props, 'imageCount') && getInstagramType(props) === 'CAROUSEL' && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'pink' },
        'slides: ',
        _lodash2.default.get(props, 'imageCount', 0)
      ),
      (_lodash2.default.get(props, 'playCount') || _lodash2.default.get(props, 'viewCount ')) && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'pink' },
        'views: ',
        (0, _formatting.sciFormatted)(_lodash2.default.get(props, 'playCount', 0) || _lodash2.default.get(props, 'viewCount', 0))
      ),
      props.platform != 'TIKTOK' && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'pink' },
        'ER: ',
        (0, _formatting.percentFormatted)(instagramEngagementRate(props)),
        '%'
      ),
      props.platform != 'TIKTOK' && _react2.default.createElement(
        'p',
        { style: captionStyle },
        _lodash2.default.truncate(_lodash2.default.get(props, 'text'), { length: 180 })
      ),
      props.platform === 'TIKTOK' && _react2.default.createElement(
        'p',
        { style: captionStyle },
        _lodash2.default.truncate(_lodash2.default.get(props, 'initialData.text'), { length: 180 })
      )
    )
  );
};

var TiktokBlock = exports.TiktokBlock = function TiktokBlock(props) {
  return _react2.default.createElement(
    _semanticUiReact.Card,
    {
      fluid: true, style: segmentStyle, onClick: function onClick() {
        return openURL(_lodash2.default.get(props, 'trackedAsset.assetURL', _lodash2.default.get(props, 'assetURL')));
      }, color: 'Black'
    },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { textAlign: 'center' },
      props.platform === 'TIKTOK' && _react2.default.createElement(_semanticUiReact.Image, {
        style: imageStyle,
        src: _lodash2.default.get(props, 'savedThumbnailUrl'),
        onError: function onError(i) {
          i.target.src = DEFAULT_IMAGE;
        }
      }),
      props.platform === 'TIKTOK' && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'black' },
        'Tiktok'
      ),
      props.platform === 'TIKTOK' && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'black' },
        'ER: ',
        (0, _formatting.percentFormatted)(tiktokEngagementRate(props)),
        '%'
      ),
      (_lodash2.default.get(props, 'playCount') || _lodash2.default.get(props, 'viewCount ')) && _react2.default.createElement(
        _semanticUiReact.Label,
        { color: 'pink' },
        'views: ',
        (0, _formatting.sciFormatted)(_lodash2.default.get(props, 'playCount', 0) || _lodash2.default.get(props, 'viewCount', 0))
      ),
      props.platform === 'TIKTOK' && _react2.default.createElement(
        'p',
        { style: captionStyle },
        _lodash2.default.truncate(_lodash2.default.get(props, 'initialData.text'), { length: 180 })
      )
    )
  );
};

var getStoryTotals = function getStoryTotals(_ref) {
  var stories = _ref.stories;

  console.log(stories);

  var totalReach = _lodash2.default.sumBy(stories, 'attributes.latestReach');
  var totalImpressions = _lodash2.default.sumBy(stories, 'attributes.latestImpressions');
  return {
    reach: totalReach,
    impressions: totalImpressions
  };
};

var isStory = function isStory(post) {
  return _lodash2.default.get(post, 'type') === 'stories' || _lodash2.default.get(post, 'trackedAsset.assetType') === 'STORY';
};

var InfluencerCard = function (_React$Component) {
  (0, _inherits3.default)(InfluencerCard, _React$Component);

  function InfluencerCard() {
    (0, _classCallCheck3.default)(this, InfluencerCard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InfluencerCard.__proto__ || (0, _getPrototypeOf2.default)(InfluencerCard)).call(this));

    _this.toggleExpandedState = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    };

    _this.toggleTiktokExpandedState = function () {
      _this.setState({
        tiktoksExpanded: !_this.state.tiktoksExpanded
      });
    };

    _this.state = {
      expanded: false,
      tiktoksExpanded: false
    };
    return _this;
  }

  (0, _createClass3.default)(InfluencerCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          handle = _props.handle,
          profilePic = _props.profilePic,
          totals = _props.totals,
          posts = _props.posts,
          orgId = _props.orgId,
          tiktoks = _props.tiktoks;


      var isJohnLewisReport = orgId === JL;
      var isGiftaReport = orgId === GIFTA;

      var discussionId = 'no_discussion_found';

      _lodash2.default.forEach(posts, function (post) {
        if (_lodash2.default.get(post, 'relationships.discussion.data.id')) {
          discussionId = _lodash2.default.get(post, 'relationships.discussion.data.id');
        } else if (_lodash2.default.get(post, 'discussionId')) {
          discussionId = _lodash2.default.get(post, 'discussionId');
        }
      });

      var matchedTiktoks = [];

      console.log(handle, discussionId);

      if (handle === 'TIKTOKS_ONLY') {
        matchedTiktoks = tiktoks;
      } else {
        matchedTiktoks = _lodash2.default.filter(tiktoks, function (tiktok) {
          return _lodash2.default.get(tiktok, 'discussion.id') === discussionId;
        });
      }

      console.log('matchedTiktoks', matchedTiktoks);

      var getER = function getER(params) {
        if (isJohnLewisReport) {
          return (0, _influencerReportCard.getJLEngagementsRate)(params);
        } else if (isGiftaReport) {
          return (0, _influencerReportCard.getGiftaEngagementsRate)(params);
        }
        return (0, _influencerReportCard.getEngagementsRate)(params);
      };

      var _state = this.state,
          expanded = _state.expanded,
          tiktoksExpanded = _state.tiktoksExpanded;


      var topThreeTiktoks = _lodash2.default.take(matchedTiktoks, 3);
      var theRestofTiktoks = _lodash2.default.takeRight(matchedTiktoks, _lodash2.default.size(matchedTiktoks) - _lodash2.default.size(topThreeTiktoks));

      var topThreePosts = _lodash2.default.take(posts, 3);
      var theRestofPosts = _lodash2.default.takeRight(posts, _lodash2.default.size(posts) - _lodash2.default.size(topThreePosts));

      var postTypes = (0, _influencerReportCard.getPostTypes)(posts || []);
      var engRate = getER({
        likes: _lodash2.default.get(totals, 'likes', 0),
        comments: _lodash2.default.get(totals, 'comments', 0),
        postsCount: _lodash2.default.get(postTypes, 'posts', 0),
        followerCount: _lodash2.default.get(totals, 'followersCount', 0),
        impressions: _lodash2.default.get(totals, 'impressions', 0)
      });

      var titkokTotals = {
        likes: _lodash2.default.sumBy(matchedTiktoks, function (tiktok) {
          var latestData = _lodash2.default.last(_lodash2.default.get(tiktok, 'tiktokData'));
          return _lodash2.default.get(latestData, 'diggCount', 0);
        }),
        shares: _lodash2.default.sumBy(matchedTiktoks, function (tiktok) {
          var latestData = _lodash2.default.last(_lodash2.default.get(tiktok, 'tiktokData'));
          return _lodash2.default.get(latestData, 'shareCount', 0);
        }),
        views: _lodash2.default.sumBy(matchedTiktoks, function (tiktok) {
          var latestData = _lodash2.default.last(_lodash2.default.get(tiktok, 'tiktokData'));
          return _lodash2.default.get(latestData, 'playCount', 0);
        }),
        comments: _lodash2.default.sumBy(matchedTiktoks, function (tiktok) {
          var latestData = _lodash2.default.last(_lodash2.default.get(tiktok, 'tiktokData'));
          return _lodash2.default.get(latestData, 'commentCount', 0);
        })
      };

      var areTiktoksPresent = !_lodash2.default.isEmpty(matchedTiktoks);
      var tiktokFollowerCount = _lodash2.default.get(_lodash2.default.head(matchedTiktoks), 'initialData.authorMeta.fans', 0);

      var followerCount = areTiktoksPresent ? tiktokFollowerCount : _lodash2.default.get(totals, 'followersCount');
      var tiktokHandle = _lodash2.default.get(_lodash2.default.head(matchedTiktoks), 'initialData.authorMeta.name') || _lodash2.default.get(_lodash2.default.head(matchedTiktoks), 'initialData.authorMeta.name.uniqueId') || handle;
      var tiktokId = _lodash2.default.get(_lodash2.default.head(matchedTiktoks), 'initialData.authorMeta.id') || _lodash2.default.get(_lodash2.default.head(matchedTiktoks), 'initialData.authorMeta.name.id');
      var tiktokEngRate = _lodash2.default.isEmpty(matchedTiktoks) ? 0 : (titkokTotals.comments + titkokTotals.likes + titkokTotals.shares) * 100 / (tiktokFollowerCount * _lodash2.default.size(matchedTiktoks));

      var tiktokProfileThumbnail = 'https://s3-eu-west-1.amazonaws.com/dyzio-tiktoks/' + tiktokId + '.jpg';
      var thumbnail = areTiktoksPresent ? tiktokProfileThumbnail : profilePic;
      return _react2.default.createElement(
        _semanticUiReact.Card,
        { fluid: true },
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4 },
                _react2.default.createElement(_semanticUiReact.Image, {
                  src: thumbnail,
                  className: 'circular',
                  size: 'tiny',
                  style: avatarStyle
                }),
                _react2.default.createElement(
                  'div',
                  { style: handleStyle },
                  _react2.default.createElement(
                    'b',
                    null,
                    _lodash2.default.truncate(tiktokHandle, {
                      length: 15
                    })
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
                  (0, _formatting.commaFormatted)(followerCount),
                  ' followers'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 12 },
                areTiktoksPresent && _react2.default.createElement(
                  _semanticUiReact.Statistic.Group,
                  { widths: 'six', size: 'tiny', style: statsStyle },
                  _react2.default.createElement(
                    _semanticUiReact.List,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      null,
                      _lodash2.default.size(matchedTiktoks),
                      ' x ',
                      _react2.default.createElement(_dyzioIcons.TiktokIcon, { additionalStyles: tiktokIconStyle }),
                      ' POST '
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Value,
                      { style: statisticValueStyle },
                      (0, _formatting.sciFormatted)(_lodash2.default.get(titkokTotals, 'likes', 0))
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Label,
                      null,
                      'likes'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Value,
                      { style: statisticValueStyle },
                      (0, _formatting.sciFormatted)(_lodash2.default.get(titkokTotals, 'shares', 0))
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Label,
                      null,
                      'shares'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Value,
                      { style: statisticValueStyle },
                      (0, _formatting.sciFormatted)(_lodash2.default.get(titkokTotals, 'views', 0))
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Label,
                      null,
                      'views'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Value,
                      { style: statisticValueStyle },
                      (0, _formatting.sciFormatted)(_lodash2.default.get(titkokTotals, 'comments', 0))
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Label,
                      null,
                      'comments'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Statistic,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Value,
                      { style: statisticValueStyle },
                      tiktokEngRate ? (0, _formatting.percentFormatted)(tiktokEngRate) + ' %' : '-'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Statistic.Label,
                      null,
                      '% eng. rate'
                    )
                  )
                ),
                !areTiktoksPresent && _react2.default.createElement(
                  'h3',
                  { style: { color: 'grey', textAlign: 'center', marginTop: 30 } },
                  'No TikTok Content Found...'
                )
              )
            )
          )
        ),
        !_lodash2.default.isEmpty(matchedTiktoks) && _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Header,
            null,
            'Tiktok Content'
          ),
          _react2.default.createElement(
            _semanticUiReact.Card.Meta,
            null,
            'Tiktok engagements are not currently included in the influencer summary'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { columns: 3 },
              _lodash2.default.map(topThreeTiktoks, function (post) {
                return _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(TiktokBlock, post)
                );
              }),
              tiktoksExpanded && _lodash2.default.map(theRestofTiktoks, function (post) {
                return _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(TiktokBlock, post)
                );
              })
            )
          )
        ),
        !_lodash2.default.isEmpty(matchedTiktoks) && _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { textAlign: 'center' },
          tiktoksExpanded ? _react2.default.createElement(
            'span',
            null,
            'showing all Tiktok posts'
          ) : _react2.default.createElement(
            'span',
            null,
            'showing top ',
            _lodash2.default.size(topThreeTiktoks),
            ' posts of ',
            _lodash2.default.size(matchedTiktoks)
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              icon: true,
              size: 'mini',
              labelPosition: 'left',
              style: buttonStyle,
              onClick: this.toggleTiktokExpandedState
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: tiktoksExpanded ? 'angle up' : 'angle down' }),
            tiktoksExpanded ? 'view top posts' : 'view all'
          )
        ),
        '        ',
        !_lodash2.default.isEmpty(topThreePosts) && _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Header,
            null,
            'Instagram Content'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { columns: 3 },
              _lodash2.default.map(topThreePosts, function (post) {
                if (isStory(post)) {
                  return _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(InstagramStoryBlock, post)
                  );
                }
                return _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(InstagramPostBlock, post)
                );
              }),
              expanded && _lodash2.default.map(theRestofPosts, function (post) {
                if (isStory(post)) {
                  return _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(InstagramStoryBlock, post)
                  );
                }
                return _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(InstagramPostBlock, post)
                );
              })
            )
          )
        ),
        !_lodash2.default.isEmpty(topThreePosts) && _react2.default.createElement(
          _semanticUiReact.Card.Content,
          { textAlign: 'center' },
          expanded ? _react2.default.createElement(
            'span',
            null,
            'showing all Instagram posts from ',
            handle
          ) : _react2.default.createElement(
            'span',
            null,
            'showing top ',
            _lodash2.default.size(topThreePosts),
            ' posts of ',
            _lodash2.default.size(posts)
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              icon: true,
              size: 'mini',
              labelPosition: 'left',
              style: buttonStyle,
              onClick: this.toggleExpandedState
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: expanded ? 'angle up' : 'angle down' }),
            expanded ? 'view top posts' : 'view all'
          )
        )
      );
    }
  }]);
  return InfluencerCard;
}(_react2.default.Component);

InfluencerCard.propTypes = {
  handle: _propTypes2.default.string.isRequired,
  profilePic: _propTypes2.default.string.isRequired,
  totals: _propTypes2.default.object.isRequired,
  posts: _propTypes2.default.array.isRequired,
  orgId: _propTypes2.default.string.isRequired
};

InfluencerCard.defaultProps = {
  handle: 'TIKTOKS_ONLY'
};

exports.default = InfluencerCard;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/tiktok-report/influencer-card.js
// module id = 1072
// module chunks = 1